module.exports = __webpack_public_path__ + "static/media/img-instagram.023018cd.svg";